'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFeisDays = undefined;

var _getFeisDays2 = require('./getFeisDays');

var _getFeisDays3 = _interopRequireDefault(_getFeisDays2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.getFeisDays = _getFeisDays3.default;


//////////////////
// WEBPACK FOOTER
// ./util/index.js
// module id = 614
// module chunks = 0